import type { RouterInputs, RouterOutputs } from '@/config/trpc';
import { RelationType } from '~/common/enums';

type CaseRouter = RouterOutputs['case'];

type CaseRouterInputs = RouterInputs['case'];

export type Case = CaseRouter['byId'];

export type CaseEntity = CaseRouter['entity']['list'][number];

export type CaseEntityAccess = CaseRouter['entity']['access'];

export type CaseEntityAccessInput = CaseRouterInputs['entity']['access'];

export type CaseTeamRelation = CaseEntityAccess['caseTeamRelations'][number];

export type CaseRelation = Case['relations'][number];

export type CreateCaseInput = CaseRouterInputs['note']['create'];

export type RelationOption = CaseRouter['relationOptions'][number];

export type Payment = Case['payments'][number];

export const isTeamRelationOption = (
  option: RelationOption,
): option is RelationOption & { companyId: string } => option.type === RelationType.Team;
